import {
  IGetPrivateClassBackEndModel,
  IPrivateClassListItemBackEndModel,
  IPrivateClassListItemFrontEndModel,
  IGetPrivateClassFrontEndModel,
  IManagePrivateClassFormModel,
} from "../types";
import { LANGUAGES } from "../../language-course/constants";

export function parsePrivateClassToFrontEndModel(
  backEndModel: IPrivateClassListItemBackEndModel[],
): IPrivateClassListItemFrontEndModel[] {
  return backEndModel;
}

export function parseManagePrivateClassToFrontEndModel(
  backEndModel: IGetPrivateClassBackEndModel,
): IManagePrivateClassFormModel {
  return {
    id: backEndModel.id,
    subjectId: backEndModel.subjectId,
    teachingLanguage: backEndModel.teachingLanguage,
    description: backEndModel.description ?? "",
    extraFiles: (backEndModel.extraFiles ?? []).map((file) => ({
      id: file.id,
      fileId: file.fileId,
      name: file.name,
      size: file.size,
      preview: file.path,
    })),
  };
}

export function parseViewPrivateClassToFrontEndModel(
  backEndModel: IGetPrivateClassBackEndModel,
  subjectName: string,
): IGetPrivateClassFrontEndModel {
  return {
    id: backEndModel.id,
    subjectName,
    teachingLanguage: LANGUAGES.find((l) => l.id === backEndModel.teachingLanguage)?.name ?? backEndModel.teachingLanguage,
    description: backEndModel.description ?? "",
    extraFiles: backEndModel.extraFiles,
  };
}
